import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, ContextStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { PropertyReviewType } from '__generated__/api/types';
import { ReviewsViewModel } from 'models/hotel';

import { UitkTab, UitkTabs } from 'uitk-react-tabs';

import { ReviewsListOnDialog } from 'components/infosite/property-details/reviews-list-on-dialog';

export interface ReviewsSortTabsProps extends LocalizedComponentProps {
  currentHotel?: CurrentHotelStore;
  context?: ContextStore;
  analytics?: AnalyticsStore;
  reviews: ReviewsViewModel;
  positiveReviews: ReviewsViewModel;
  criticalReviews: ReviewsViewModel;
  onMoreReviews: (boolean, string?) => void;
}

@withLocalization
@inject('currentHotel', 'context', 'analytics')
@observer
export class ReviewsSortTabs extends React.Component<ReviewsSortTabsProps> {
  public constructor(props) {
    super(props);

    this.onTabClick = this.onTabClick.bind(this);
  }

  private onTabClick(selectedTab) {
    const { context, currentHotel, l10n } = this.props;

    this.initializeOmnitureTrackingForReviews(selectedTab);

    switch (selectedTab) {
      case l10n.formatText('hotels.infosite.reviews.tab.positive'):
        if (currentHotel.positiveReviews.userReviews.length === 0 && currentHotel.positiveReviews.totalReviewsRequested === 0) {
          currentHotel.fetchReviews(context, currentHotel.hotelId, true, PropertyReviewType.POSITIVE);
        }
        break;
      case l10n.formatText('hotels.infosite.reviews.tab.critical'):
        if (currentHotel.criticalReviews.userReviews.length === 0 && currentHotel.criticalReviews.totalReviewsRequested === 0) {
          currentHotel.fetchReviews(context, currentHotel.hotelId, true, PropertyReviewType.CRITICAL);
        }
        break;
      default:
    }
  }

  private initializeOmnitureTrackingForReviews(reviewSortType) {
    let opts = '';
    const { l10n, analytics } = this.props;
    const recentTabName = l10n.formatText('hotels.infosite.reviews.tab.recent.label');
    const positiveTabName = l10n.formatText('hotels.infosite.reviews.tab.positive');
    const criticalTabName = l10n.formatText('hotels.infosite.reviews.tab.critical');

    switch (reviewSortType) {
      case recentTabName:
        opts = '.Reviews.SortBy.DATEDESC';
        break;

      case positiveTabName:
        opts = '.Reviews.SortBy.RATINGDESC';
        break;

      case criticalTabName:
        opts = '.Reviews.SortBy.RATINGASC';
        break;
    }

    analytics.clickTracker(opts, 'Change tab on click', '', '', '')();
  }

  public render() {
    const { reviews, positiveReviews, criticalReviews, l10n, onMoreReviews } = this.props;
    const recentTabName = l10n.formatText('hotels.infosite.reviews.tab.recent.label');
    const positiveTabName = l10n.formatText('hotels.infosite.reviews.tab.positive');
    const criticalTabName = l10n.formatText('hotels.infosite.reviews.tab.critical');

    const onMoreRecentReviews = () => onMoreReviews(true);
    const onMoreCriticalReviews = () => onMoreReviews(true, PropertyReviewType.CRITICAL);
    const onMorePositiveReviews = () => onMoreReviews(true, PropertyReviewType.POSITIVE);

    return (
      <UitkTabs selectedTab={recentTabName} className="reviews-tabs-all" onTabSelect={this.onTabClick}>
        <UitkTab name={recentTabName} data-toggle="positive">
          {reviews && <ReviewsListOnDialog onMoreReviews={onMoreRecentReviews} areTabsPresent={true} />}
        </UitkTab>
        <UitkTab name={positiveTabName}>
          {positiveReviews && (
            <ReviewsListOnDialog reviewsType={PropertyReviewType.POSITIVE} onMoreReviews={onMorePositiveReviews} areTabsPresent={true} />
          )}
        </UitkTab>
        <UitkTab name={criticalTabName}>
          {criticalReviews && (
            <ReviewsListOnDialog reviewsType={PropertyReviewType.CRITICAL} onMoreReviews={onMoreCriticalReviews} areTabsPresent={true} />
          )}
        </UitkTab>
      </UitkTabs>
    );
  }
}
